<template>
  <div class="roi-radio-group">
    <span class="roi-group-title">{{label}}</span>
    <v-radio-group
      :name="name"
      :value="value"
      @change="changed"
    >
      <v-radio
        v-for="(val, key) in options"
        :key="key"
        :label="val"
        :value="key"
        class="roi-radio"
        on-icon="mdi-checkbox-marked-circle-outline"
        color="white"
      ></v-radio>
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: 'RadioButton',
  props: ['label', 'name', 'options', 'value'],
  data () {
    return {
    }
  },
  methods: {
    changed(value) {
      this.$emit('input',value);
    },
  }
}
</script>
<style lang="scss">

@import '../../src/sass/variables.scss';

@import '~vuetify/src/styles/settings/_variables';


.v-input--radio-group__input {
  width: auto !important;
  display: block !important;
}
.roi-radio {
  border-radius: 20px;
  display: table !important;
  background:#EBEBEB;
  padding:10px 20px;
}

.v-input--radio-group--column .roi-radio:not(:last-child):not(:only-child) {
  margin-bottom: 16px;
}

.v-input--radio-group {
  padding-top: 0;
}

.roi-radio.v-item--active {
  background: $c-dehn-red;
  label {
    color: $c-dehn-white;
  }
}

.roi-radio-group {
  .v-input--selection-controls {
    padding-top: 0;
  }
}

.v-input--selection-controls .v-radio > .v-label {
  display: table-cell !important;
  vertical-align: middle;
}

</style>
